import React, { useState } from "react";
import Button from "components/CustomButton";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useToasts } from "react-toast-notifications";
import { ReactComponent as CloseIcon } from "assets/img/icons/cancel.svg";
import { Modal } from "react-responsive-modal";
import backGroundImage from "assets/img/background-poll.jpeg";
import PollService from "services/pollServices";
import GeneralService from "services/GeneralService";
import { useUserContext } from "store/contexts/userContext";
import moment from "moment";
import { ErrorMessage } from "utils/ErrorMessage";
import BackArrow from "assets/img/back.svg";
import AddEditForm from "./AddEditForm.js";
import { useGlobalContext } from "store/contexts/globalContext";

export default ({
  team,
  modelOpen,
  closeModal,
  singleTeam,
  createNewPost = null,
  createNewPoll = null,
}) => {
  const { user } = useUserContext();
  const { microsoftTeamsVideoText } = useGlobalContext();
  const [loading, setLoading] = useState(false);
  const [selectedTeams, setSelectedTeams] = useState(
    team?.id ? [team?.id] : []
  );
  const [teamError, setTeamError] = useState("");
  const [uploadProgress, setUploadProgress] = useState(0);
  const { addToast } = useToasts();
  Yup.addMethod(Yup.array, "unique", function (message) {
    return this.test("unique", message, function (responses) {
      const mapper = (item) => item.response?.toUpperCase();
      const uniqueResponses = [...new Set(responses.map(mapper))];
      const isUnique = responses.length === uniqueResponses.length;
      if (isUnique) {
        return true;
      }
      const idx = responses.findIndex(
        (item, index) => mapper(item) !== uniqueResponses[index]
      );
      let addOptions = [];
      (responses || []).map((item, index) => {
        if (idx === index) {
          return addOptions.push({ response: message });
        }
        return addOptions.push({ response: "" });
      });
      return this.createError({
        path: `addOptions`,
        message: [addOptions],
      });
    });
  });
  const formik = useFormik({
    validateOnChange: false,
    validateOnBlur: false,
    initialValues: {
      question: "",
      attachment: null,
      end_time: new Date(),
      addOptions: [
        {
          response: "",
          label: "Response 1",
          fieldName: "response",
        },
        {
          response: "",
          label: "Response 2",
          fieldName: "response",
        },
      ],
      showTeamModel: false,
    },
    validationSchema: Yup.object().shape({
      question: Yup.string()
        .min(4, "Question must be between 4 to 5000 characters.")
        .max(5000, "Question must be between 4 to 5000 characters.")
        .required("Please enter the question."),
      end_time: Yup.date().required("End time is required"),
      addOptions: Yup.array()
        .of(
          Yup.object().shape({
            response: Yup.string()
              .max(251, "Response cannot be greater then 250")
              .required("Please enter response"),
          })
        )
        .unique("Response value must be unique"),
    }),
    onSubmit: async (values) => {
      setTeamError("");
      setUploadProgress(0);
      if ((selectedTeams || []).length === 0) {
        setTeamError("Please Select Team");
        return false;
      }
      setLoading(true);
      formik.values.newModal = false;
      try {
        let media = null;
        if (values.attachment) {
          const preSignedResponse = await GeneralService.getPresignedUploadURL({
            filename: values.attachment.name,
            mime_type: values.attachment.type,
            file_size: values.attachment.size,
            resource_type: "user",
            resource_id: user ? user.id : "",
            resource_policy: "team.poll",
          });
          const { key, url } = preSignedResponse.data.data;

          await GeneralService.uploadToS3(
            url,
            values.attachment,
            (progress) => {
              setUploadProgress(progress);
            }
          );

          media = key;
        }

        const data = await PollService.createPoll({
          content: values.question,
          end_date: moment(values.end_time).format("YYYY-MM-DD"),
          options: values.addOptions.map((item) => {
            return item.response;
          }),
          team_ids: selectedTeams,
          media: media,
          attachment: values.attachment,
        });

        if (values.attachment) {
          var attachmentType = values.attachment.type.split("/");
        }

        setUploadProgress(100);
        formik.resetForm();
        setLoading(false);
        closeModal();
        setSelectedTeams([]);

        if (
          attachmentType &&
          attachmentType[0] === "video" &&
          attachmentType[1] !== "mp4" &&
          !microsoftTeamsVideoText
        ) {
          addToast(
            "Your poll is being processed. We’ll let you know when it’s ready to view. ",
            { appearance: "info" }
          );
          return;
        }

        if (singleTeam) {
          var postData = {
            content: data.data.data.content,
            id: data.data.data.id,
            media: data.data.data.media,
            media_type_id: data.data.data.media_type_id,
            status: data.data.data.status,
            team_poll_id: data.data.data.id,
          };

          createNewPost(
            postData,
            data.data.data.team_post_id,
            data.data.data.post.updated_at,
            { name: "poll", id: data.data.data.post.type_id }
          );
          createNewPoll(data?.data?.data);
        }

        formik.setFieldValue("showTeamModel", false);
        addToast(data.data.message || "New Poll Created Successfully", {
          appearance: "success",
        });
      } catch (error) {
        console.log(error, "Poll Creation Error");
        setLoading(false);
        if (
          error.response &&
          error.response.data &&
          error.response.data.status === 405
        ) {
          addToast(error?.response?.data?.message || "Url Not Found", {
            appearance: "error",
          });
        } else {
          ErrorMessage(error, "Poll Creation Error Occur", addToast);
        }
      }
    },
  });

  const closeDialog = () => {
    formik.resetForm();
    setLoading(false);
    setSelectedTeams([]);
    formik.setFieldValue("showTeamModel", false);
    closeModal();
  };

  const onAttachmentSelected = (file) => {
    formik.setFieldValue("attachment", file);
  };

  const clearAttachment = () => {
    formik.setFieldValue("attachment", null);
  };

  const addMoreOptions = () => {
    const lengthComplete = formik.values.addOptions.length === 5;
    if (!lengthComplete) {
      const addOptions = formik.values.addOptions.push({
        response: "",
        label: `Response ${formik.values.addOptions.length + 1}`,
        fieldName: `response`,
      });
      formik.setFieldValue({ ...formik.values, addOptions });
    }
  };

  const selectTeams = (teams) => {
    setSelectedTeams(teams);
  };

  const showTeams = () => {
    formik.validateForm().then((res) => {
      if (Object.keys(res).length === 0) {
        formik.setFieldValue("showTeamModel", true);
      }
    });
  };

  const setValue = (value) => {
    var data = value;
    if (formik.values.question) {
      let result = formik.values.question.concat("\n", value);
      data = result;
    }

    formik.setFieldValue("question", data);
  };

  return (
    <>
      <Modal
        open={modelOpen}
        onClose={closeDialog}
        showCloseIcon={false}
        closeOnEsc={false}
        closeOnOverlayClick={false}
        classNames={{
          modalContainer: "pollModalContainer",
          modal: "pollModal",
        }}
      >
        <div
          className="poll-modal-image"
          style={{ backgroundImage: `url(${backGroundImage})` }}
        >
          <div className="pollModalHeader text-center">
            {formik.values.showTeamModel ? (
              <div
                className="pollHeaderBack"
                onClick={
                  loading
                    ? null
                    : () => {
                        formik.setFieldValue("showTeamModel", false);
                      }
                }
              >
                <img src={BackArrow} alt="Back" className="backArrow" />
              </div>
            ) : null}

            {formik.values.showTeamModel ? "Select Team" : "Create Poll"}
            <Button
              type="button"
              buttonClass="btn-close"
              disabled={loading && true}
            >
              <CloseIcon onClick={closeDialog} />
            </Button>
          </div>
          <div className="pollModalContent" id="pollModal">
            <AddEditForm
              formik={formik}
              addMoreOptions={addMoreOptions}
              selectTeams={selectTeams}
              uploadProgress={uploadProgress}
              loading={loading}
              teamError={teamError}
              onAttachmentSelected={onAttachmentSelected}
              clearAttachment={clearAttachment}
              selectedTeams={selectedTeams}
              showTeams={showTeams}
              singleTeam={singleTeam}
              setValue={setValue}
            />
          </div>
        </div>
      </Modal>
    </>
  );
};
